import { Component, Inject, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { OtpUtil, RoutePatternStops } from '@ridango/components';
import Env from '@ridango/core/env';

@Component({
    selector: 'rwidget-route-direction-list-modal',
    templateUrl: './route-direction-list-modal.html',
    styleUrls: ['./route-direction-list-modal.scss']
})
export class RouteDirectionListModalComponent {
    patternLabels: string[] = [];

    private _routePatternStops: RoutePatternStops[] = [];

    @Input() set routePatternStops(value: RoutePatternStops[]) {
        this._routePatternStops = value ?? [];
        const preferHeadsign = this.env.EXPLORE?.PATTERN_LABEL_PREFER_HEADSIGN === true;
        this.patternLabels = this._routePatternStops.map((o) =>
            OtpUtil.getPatternDisplayLabel(o.pattern, preferHeadsign)
        );
    }

    get routePatternStops(): RoutePatternStops[] {
        return this._routePatternStops;
    }

    @Input() selectedOption: RoutePatternStops;

    constructor(
        @Inject('ENV') public env: Env,
        private modalCtrl: ModalController
    ) {}

    async cancel(): Promise<void> {
        await this.modalCtrl.dismiss(null, 'cancel');
    }

    handleSaveClick() {
        this.modalCtrl.dismiss(this.selectedOption, 'save');
    }

    handleDirectionChange(direction) {
        this.selectedOption = direction;
    }
}
